import type { Store } from '@ngrx/store';
import { createFeatureSelector, select } from '@ngrx/store';
import type { AdCycle, AdsState } from './ads.model';
import type { AdsPartialState } from './ads.reducer';
import { ADS_FEATURE_KEY } from './ads.reducer';
import type { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export const getAdsState = createFeatureSelector<AdsState>(ADS_FEATURE_KEY);

export function getCurrentAdCycle(
  store: Store<AdsPartialState>
): Observable<AdCycle & Pick<AdsState, 'thirdpartyads'>> {
  return store.pipe(
    select(getAdsState),
    filter((adsState) => adsState.googletagIsLoaded && !!adsState.currentCycle.id),
    map((adsState) => ({ ...adsState.currentCycle, thirdpartyads: adsState.thirdpartyads }))
  );
}
